import {Component, Input, Output, EventEmitter, OnInit, ViewChild, AfterViewInit, ChangeDetectionStrategy} from '@angular/core';
import { IrbEditorComponent } from "@irb/irb-editors/irb-editors.com";
import { IPortfolioResultResponse, IPortfolioResultPFSECRebal, IPortfolioResultChartData } from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {PrAllocationsService} from "@irb/irb-editors/editor-portfolio-result/services";

@Component({
  selector: 'irb-com-pr-allocation-chart-legacy',
  standalone: false,
  templateUrl: './com-pr-allocation-chart-legacy.component.html',
  styleUrl: './com-pr-allocation-chart-legacy.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrAllocationChartLegacyComponent extends IrbEditorComponent implements OnInit, AfterViewInit {
  _data: IPortfolioResultResponse;
  @Output() change = new EventEmitter<boolean>();
  chartDataSecTypeBefore: any;
  chartDataSecTypeAfter: any;
  chartDataCustCatBefore: any;
  chartDataCustCatAfter: any;
  dataCustCat: Array<IPortfolioResultChartData>;
  dataSecType: Array<IPortfolioResultChartData>;

  tableDataSource: MatTableDataSource<IPortfolioResultChartData>;
  tableColumns = ['color', 'beforeTotal', 'group', 'afterTotal', 'color'];

  @ViewChild(MatSort) sort: MatSort;

  colors: Array<string> = ["#0061AF", "#652D90", "#008641", "#F15A22", "#BA006F", "#0083CA", "#CC99FF", "#9ACA3C", "#F58220", "#F5A4C7", "#7BAFDE", "#9B6DCC", "#3A7224", "#FED09E", "#00B6F1", "#6F60AA", "#DDE89A", "#FCAF17", "#8ED8F8", "#CBDB2A", "#FBB034", "#00ACD4", "#B5AF75", "#007B8D", "#669156", "#00B3B5", "#8C9B1B", "#ADE0EE", "#8FCEA5", "#9FCBED", "#00AE4D", "#72CDF4", "#78A22F", "#009DDC", "#8FCEA5", "#009AC7"];

  options: any = {
    responsive: true,
    maintainAspectRatio: false,
    rotation: Math.PI,
    cutoutPercentage: 50,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const label = context.label;
            const value = context.dataset.data[context.dataIndex].toFixed(1);
            return label + " is " + value + "%";
          }
        }
      }
    }
  };

  constructor(public pralloc: PrAllocationsService) {
    super();
  }

  ngOnInit() {
    this.populateChartData();
  }

  ngAfterViewInit(): void {
    this.tableDataSource.sort = this.sort;
  }

  onDataChange() {
    this.populateChartData();
  }

  populateChartData() {
    let percentagesBefore: Array<number> = [];
    let percentagesAfter: Array<number> = [];
    let labels: Array<string> = [];
    this.dataSecType = [];
    this.dataCustCat = [];
    let colorIndex: number = 0;
    let colors: Array<string> = [];

    // group data by security type or custom category
    this.pralloc.getFilteredItemsForChart(this.data, false).forEach((r: IPortfolioResultPFSECRebal) => {
        // sum percentages by security type
        if(r.secType !== "OPTION") {
          const f = this.dataSecType.find((x: IPortfolioResultChartData) => x.group === r.secType);

          if(f) {
            f.beforeTotal += r.secCurPercntVal;
            f.afterTotal += r.secPercntValAfterAdj;
          } else {
            this.dataSecType.push({
              beforeTotal: r.secCurPercntVal,
              afterTotal: r.secPercntValAfterAdj,
              group: r.secType
            } as IPortfolioResultChartData);
          }
        }

        // sum percentages by custom category
        const f = this.dataCustCat.find((x: IPortfolioResultChartData) => x.group === r.secCatagory);

        if(f) {
          f.beforeTotal += r.secCurPercntVal;
          f.afterTotal += r.secPercntValAfterAdj;
        } else {
          this.dataCustCat.push({
            beforeTotal: r.secCurPercntVal,
            afterTotal: r.secPercntValAfterAdj,
            group: r.secCatagory
          } as IPortfolioResultChartData);
        }
    });
  
    this.dataSecType.forEach((r: IPortfolioResultChartData) => {
      percentagesBefore.push(r.beforeTotal);
      percentagesAfter.push(r.afterTotal);
      colors.push(this.colors[colorIndex]);
      labels.push(r.group);
      r.color = this.colors[colorIndex];
      colorIndex++;
    });

    this.chartDataSecTypeBefore = {
      labels: labels,
      datasets: [
        {
          data: percentagesBefore,
          backgroundColor: colors,
          hoverBackgroundColor: colors,
          borderWidth: 0,
          hoverBorderColor: ["#FFFFFF"]
        }
      ]
    };
        
    this.chartDataSecTypeAfter = {
      labels: labels,
      datasets: [
        {
          data: percentagesAfter,
          backgroundColor: colors,
          hoverBackgroundColor: colors,
          borderWidth: 0,
          hoverBorderColor: ["#FFFFFF"]
        }
      ]
    };

    //reset
    percentagesBefore = [];
    percentagesAfter = [];
    colors = [];
    labels = [];
    colorIndex = 0;

    this.dataCustCat.forEach((r: IPortfolioResultChartData) => {
      percentagesBefore.push(r.beforeTotal);
      percentagesAfter.push(r.afterTotal);
      labels.push(r.group);
      
      if(r.group === "Uncategorized") {
        colors.push("#BABABA");
        r.color = colors[colors.length - 1];
      } else {
        colors.push(this.colors[colorIndex]);
        r.color = this.colors[colorIndex];
        colorIndex++;
      }
    });

    this.chartDataCustCatBefore = {
      labels: labels,
      datasets: [
        {
          data: percentagesBefore,
          backgroundColor: colors,
          hoverBackgroundColor: colors,
          borderWidth: 0,
          hoverBorderColor: ["#FFFFFF"]
        }
      ]
    };
        
    this.chartDataCustCatAfter = {
      labels: labels,
      datasets: [
        {
          data: percentagesAfter,
          backgroundColor: colors,
          hoverBackgroundColor: colors,
          borderWidth: 0,
          hoverBorderColor: ["#FFFFFF"]
        }
      ]
    };

    this.tableDataSource = new MatTableDataSource(this.dataCustCat);
    this.tableDataSource.sort = this.sort;
  }

  @Input()
  get data(): any {
    return this._data;
  }

  set data(d: any) {
    this._data = d;
  }
}
